export default import.meta.ROLLDOWN_FILE_URL_nKu7dUy_Rjg5ysps7E8aBA